import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline, createTheme, ThemeProvider } from "@mui/material";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";

const theme = createTheme({
  palette: { primary: { main: "#0067FF" }, secondary: { main: "#111827" } },
  shape: { borderRadius: 16 },
});

// If someone visits /app/... mount the router with that base; else use root.
const basename = window.location.pathname.startsWith("/app") ? "/app" : "/";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <BrowserRouter basename={basename}>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>
);
